export default "__VITE_ASSET__bfQUVDjo__"